module.exports = __webpack_public_path__ + "static/media/walkie-talkie.d43580c0.svg";